import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExtensionService {

  private isChromeExtensionInstalled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isChromeExtensionInstalled$: Observable<boolean> = this.isChromeExtensionInstalled.asObservable();
  set chromeExtensionInstalled(value: boolean) {
    this.isChromeExtensionInstalled.next(value);
  }
  get chromeExtensionInstalled(): boolean {
    return this.isChromeExtensionInstalled.getValue();
  }

  constructor() { }


  checkExtensionStatus() {
    setTimeout(() => {
      const uniqueElement = document.querySelector('#salesommo-extension-presence');
      if (uniqueElement) {
        this.isChromeExtensionInstalled.next(true);
      } else {
        this.isChromeExtensionInstalled.next(false);
      }
    }, 1000);
  }


}
